import React, {useCallback, useRef, useState} from 'react';

import {cls} from '../../utils';
import {ChevronDownIcon} from '../svg-icon';

import css from './details.module.css';

type Props = {
	summary: React.ReactNode | string;
	className?: string;
	summaryClassName?: string;
	children?: React.ReactNode;
};

function onSchedule(fn: () => void) {
	/* да, здесь два requestAnimationFrame */
	requestAnimationFrame(function () {
		requestAnimationFrame(function () {
			fn();
		});
	});
}

function makeOpen(element: HTMLDivElement) {
	return new Promise((resolve) => {
		element.style.height = `${element.scrollHeight}px`;
		onSchedule(function () {
			element.addEventListener('transitionend', function onTransitionEnd() {
				element.removeEventListener('transitionend', onTransitionEnd);
				element.style.height = '';
				resolve(undefined);
			});
		});
	});
}

function makeClose(element: HTMLDivElement) {
	return new Promise((resolve) => {
		element.style.height = `${element.scrollHeight}px`;
		onSchedule(function () {
			element.style.height = '';
			resolve(undefined);
		});
	});
}

export const Details: React.FC<Props> = ({className, summary, summaryClassName, children, ...p}) => {
	const [open, setOpen] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	const handleChange = useCallback(() => {
		const promise = open ? makeClose(contentRef.current!) : makeOpen(contentRef.current!);
		promise.then(() => {
			setOpen(!open);
		});
	}, [open]);

	return (
		<div className={cls(css.details, className)}>
			<div className={cls(css.summary, summaryClassName)} onClick={handleChange}>
				{summary}
				<ChevronDownIcon className={cls(css.arrow, open && css.open)} />
			</div>

			<div className={cls(css.content, !open && css.close)} ref={contentRef}>
				{children}
			</div>
		</div>
	);
};
